import Charts from "@streemau/charts";

import alert from "shared/boot/alert";
import analytics from "shared/boot/analytics";
import api from "shared/boot/api";
import app from "shared/boot/app";
import appConfig from "shared/boot/appConfig";
import sharedComponents from "shared/boot/components";
import emitter from "shared/boot/emitter";
import errors from "shared/boot/errors";
import features from "shared/boot/features";
import hydrateState from "shared/boot/hydrateState";
import i18n from "shared/boot/i18n";
import locale from "shared/boot/locale";
import modals from "shared/boot/modals";
import permissions from "shared/boot/permissions";
import rollbar from "shared/boot/rollbar";
import shortcuts from "shared/boot/shortcuts";
import virtualScroller from "shared/boot/virtualScroller";
import vueDraggableResizable from "shared/boot/vueDraggableResizable";
import { safePush, safeReplace } from "shared/helpers/routing";

import QItemRestricted from "src/components/common/QItemRestricted.vue";
import RestrictedRouterLink from "src/components/common/RestrictedRouterLink.vue";
import { useUserStore } from "src/stores/user";

import components from "./components";
import navigationGuards from "./navigation-guards";
import patchPreviewLogin from "./patchPreviewLogin";

import "@streemau/charts/dist/charts.css";

export default async (ctx) => {
  const isMobile = false;
  const isDesktop = true;
  const isAdminMode = true;

  ctx.app.provide("isMobile", isMobile);
  ctx.app.provide("isDesktop", isDesktop);
  ctx.app.provide("isAdminMode", isAdminMode);

  ctx.app.config.globalProperties.$isMobile = isMobile;
  ctx.app.config.globalProperties.$isDesktop = isDesktop;
  ctx.app.config.globalProperties.$isAdminMode = isAdminMode;

  ctx.app.component("RestrictedRouterLink", RestrictedRouterLink);
  ctx.app.component("QItemRestricted", QItemRestricted);
  ctx.app.use(Charts);

  await patchPreviewLogin(ctx);
  await hydrateState(ctx);
  await locale(ctx);

  const userStore = useUserStore();

  rollbar(ctx);
  i18n(ctx);
  analytics(ctx);
  app(ctx);
  appConfig(ctx);
  api({ ...ctx, userStore });
  errors({ ...ctx, userStore });
  navigationGuards(ctx);
  features(ctx);
  alert(ctx);
  shortcuts(ctx);
  sharedComponents(ctx);
  components(ctx);
  modals(ctx);
  permissions(ctx);
  vueDraggableResizable(ctx);
  emitter(ctx);
  virtualScroller(ctx);

  ctx.app.config.globalProperties.$safeRouterPush = safePush(ctx);
  ctx.app.config.globalProperties.$safeRouterReplace = safeReplace(ctx);
};
